import { render, staticRenderFns } from "./RepairReportList.vue?vue&type=template&id=fafb897c&scoped=true&"
import script from "./RepairReportList.vue?vue&type=script&lang=js&"
export * from "./RepairReportList.vue?vue&type=script&lang=js&"
import style0 from "./RepairReportList.vue?vue&type=style&index=0&id=fafb897c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafb897c",
  null
  
)

export default component.exports